var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomepagesFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 5.25C21.6562 4.40431 20.9707 3.71875 20.125 3.71875H19.25C18.4043 3.71875 17.7188 4.40431 17.7188 5.25V6.57047L15.9102 4.6517C14.874 3.55232 13.126 3.55232 12.0898 4.6517L5.96478 11.1501C5.50569 11.6371 5.25 12.2812 5.25 12.9505V21.875C5.25 22.8415 6.0335 23.625 7 23.625H11.375V16.625C11.375 16.1418 11.7668 15.75 12.25 15.75H15.75C16.2332 15.75 16.625 16.1418 16.625 16.625V23.625H21C21.9665 23.625 22.75 22.8415 22.75 21.875V12.9505C22.75 12.2812 22.4943 11.6371 22.0352 11.1501L21.6562 10.748V5.25Z",
    fill: "#1B2332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepagesFilled);
export default __webpack_public_path__ + "static/media/homepages_filled.757f16f673f5f79d3e3728661c71035e.svg";
export { ForwardRef as ReactComponent };